import { ASC } from '@atlassian/jira-common-constants/src/sort-directions.tsx';
import type { ExpandList } from '@atlassian/jira-shared-types/src/rest/jira/page.tsx';
import type { Query } from './index.tsx';
import { NAME } from './sort-field.tsx';

export const ITEMS_PER_PAGE = 25;

export const initialQuery: Query = {
	sortField: NAME,
	sortDirection: ASC,
	page: 1,
	filter: {
		query: undefined,
		project: undefined,
		group: undefined,
		owner: undefined,
	},
};

export const EXPAND_PARAMETERS: ExpandList = [
	'owner',
	'favourite',
	'favouritedCount',
	'sharePermissions',
	'editPermissions',
	'description',
	'isWritable',
];
